import { addDoc, collection, doc, getDocs, limit, query, QueryDocumentSnapshot, setDoc, SnapshotOptions, where, WithFieldValue } from "firebase/firestore";
import { db } from "../firebase";
import { CompanyDb } from "./models/CompanyDb";
import { firebaseDataConverter } from "./Converters/FirebaseConverter";
import { Product, ProductFromDbMapper, ProductToDbMapper } from "../models/Product";
import { ProductDb } from "./models/ProductDb";
import { v4 as uuidv4 } from 'uuid';

class ProductService {
    private static instance: ProductService | null = null;

    private static tableName: string = "product";
    public static getInstance(): ProductService {
        if (this.instance === null) {
            this.instance = new ProductService();
        }
        return this.instance;
    }

    public async getProductsAsync(): Promise<Product[]> {
        const documents = await getDocs(query(collection(db, ProductService.tableName)).withConverter<ProductDb>(firebaseDataConverter))
        const mapped = documents.docs.map(doc => {
            var data = doc.data()
            return ProductFromDbMapper(data);
        });
        return mapped;
    }

    public async getProductsByCompanyGuid(companyGuid: string): Promise<Product[]> {

        const q = query(collection(db, ProductService.tableName), where("companyGuid", "==", companyGuid)).withConverter<ProductDb>(firebaseDataConverter);

        const documents = await getDocs(q)
        const mapped = documents.docs.map(doc => {
            var data = doc.data()
            return ProductFromDbMapper(data);
        });
        return mapped;
    }

    public async getProductByGuidAsync(guid: string): Promise<Product | null> {
        const q = query(collection(db, ProductService.tableName),
            where("guid", "==", guid),
            limit(1)).withConverter<ProductDb>(firebaseDataConverter);
        const documents = await getDocs(q)
        if (documents.docs.length < 1) return null;
        return ProductFromDbMapper(documents.docs[0].data());
    }

    public async addProductAsync(company: Product): Promise<void> {
        var mappedDb = ProductToDbMapper(company);
        await setDoc(doc(db, ProductService.tableName, uuidv4()).withConverter<ProductDb>(firebaseDataConverter), mappedDb);
    }
}

const useProductService = () => {
    return ProductService.getInstance();
}

export default useProductService;

